import { MultiSelect as MMultiSelect } from '@mantine/core';
import classes from './multiSelect.module.scss';

export const MultiSelect = MMultiSelect.extend({
  classNames: classes,
});
